import { defineComponent as _defineComponent } from 'vue'
import {
  computed, Ref, ref, watch,
} from 'vue';

import store from '~store';


export default /*#__PURE__*/_defineComponent({
  __name: 'MapTilerSearchResults',
  props: {
  visible: {
    type: Boolean,
    required: true,
  },
  select: {
    type: Function,
    required: true,
  },
  search: {
    type: String,
    default: '',
  },
  focusInput: {
    type: Function,
    required: true,
  },
  focusedInput: {
    type: Boolean,
    required: true,
  },
  focusedSuggestions: {
    type: Boolean,
    required: true,
  },
},
  setup(__props) {

const props = __props

const { region } = store.state;

const loading = computed(() => region.searchLoading);



const regionSuggestions = ref() as Ref<HTMLElement[]>;

function focusSuggestion(
  index: number,
) {
  switch (index) {
    case regionSuggestions.value?.length:
    case -1:
      props.focusInput();
      break;

    default:
      regionSuggestions.value[index]?.focus?.();
      break;
  }
}

function focusSuggestions() {
  regionSuggestions.value[0].focus();
}

watch(computed(() => props.focusedSuggestions), (val) => {
  if (val) {
    focusSuggestions();
  }
});

return { __sfc: true,region, loading, props, regionSuggestions, focusSuggestion, focusSuggestions, store }
}

})